//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    zabbixMonitoringStatus: {
      type: String,
      default () {
        return null
      }
    }
  },
  methods: {
    getZabbixMonitoringStatus: function () {
      if (this.zabbixMonitoringStatus === 'Работает') {
        return 'status-work'
      } else if (this.zabbixMonitoringStatus === 'Не работает') {
        return 'status-not-work'
      }
    }
  }
}

